import { IChatbotActionButtons } from '../../services/fetchChatbotActionButtons';
import { EPeriodicity } from '../../services/fetchChatbotMessages';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatbotActionTypes {
  SetChatbotRowVersion = 'chatbot/setChatbotRowVersion',
  SetChatbotUnreadMessagesCount = 'chatbot/setUnreadMessagesCount',
  SetChatbotPollingIntervalId = 'chatbot/setPollingIntervalId',
  SetChatbotPeriodicity = 'chatbot/setPeriodicity',
  SetChatbotHasPollAnswers = 'chatbot/setHasPollAnswers',
  ToggleChatbotPeriodicityMenu = 'chatbot/togglePeriodicityMenu',
  SetChatbotActionButtons = 'chatbot/setActionButtons',
  SetChatbotIsTyping = 'chatbot/setIsTyping',
  SetChatbotMessageSending = 'chatbot/messageSending',
  SetChatbotIsOpenEventSent = 'chatbot/isOpenEventSent',
}

export type TToggleChatbotPeriodicityMenu = ITypedReduxAction<
  EChatbotActionTypes.ToggleChatbotPeriodicityMenu,
  boolean
>;

export type TChatbotActions =
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotRowVersion, number>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotUnreadMessagesCount, number>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotPollingIntervalId, number | null>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotPeriodicity, EPeriodicity>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotHasPollAnswers, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotActionButtons, IChatbotActionButtons>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotIsTyping, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotMessageSending, boolean>
  | ITypedReduxAction<EChatbotActionTypes.SetChatbotIsOpenEventSent, boolean>
  | TToggleChatbotPeriodicityMenu;
